const { APP_DOMAIN } = Config;
import { rand } from "../../common/helpers/rand.js";

export function GenerateDomain() {
    const time = Date.now().toString(36).split("").reverse().join("");
    const text = rand(9999999999, 9999999999999999)
        .toString(36)
        .replace(/^(.{4})(.{4}).*?$/, "$1-$2");

    const rnd = `${time}-${text}`;

    return `pb-${rnd}.${APP_DOMAIN}`;
}
